import { TransactionsFilters } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: TransactionsFilters = {
  search: '',
  account: '',
  campaign: '',
  period: '',
  type: '',
  datePeriod: '',
  dateRange: '',
  customStartDate: null,
  customEndDate: null,
  status: '',
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const getPeriodOptions = (t: (key: string) => string): FilterOption[] => [
  { key: '7days', label: t('partner.revshare.transactions.filters.period7days') || '7 дней' },
  { key: '14days', label: t('partner.revshare.transactions.filters.period14days') || '14 дней' },
  { key: '30days', label: t('partner.revshare.transactions.filters.period30days') || '30 дней' },
];

export const getCampaignTypeOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('partner.revshare.transactions.filters.allCampaigns') || 'Все кампании' },
  { key: 'cpl', label: 'CPL' },
  { key: 'refshare', label: 'RevShare' },
];

export const getTypeOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('global.common.all') || 'Все' },
  { key: 'tips', label: t('partner.revshare.transactions.filters.typeTips') || 'Чаевые' },
  {
    key: 'subscribes',
    label: t('partner.revshare.transactions.filters.typeSubscription') || 'Подписка',
  },
  {
    key: 'chat_messages',
    label:
      t('partner.revshare.transactions.transactionTypes.messagePayment') || 'Оплата за сообщение',
  },
  { key: 'post', label: t('partner.revshare.transactions.filters.typePosts') || 'Посты' },
];

export const getStatusOptions = (t: (key: string) => string): FilterOption[] => [
  {
    key: 'done',
    label: t('partner.revshare.transactions.filters.statusCompleted') || 'Done',
  },
  {
    key: 'loading',
    label: t('partner.revshare.transactions.filters.statusWaiting') || 'Loading',
  },
  {
    key: 'undo',
    label: t('partner.revshare.transactions.filters.statusCancelled') || 'Undo',
  },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: 'ID', key: 'id' },
  { name: t('partner.revshare.transactions.table.campaign'), key: 'campaign' },
  { name: t('partner.revshare.transactions.table.userTransaction'), key: 'user' },
  { name: t('partner.revshare.transactions.table.status'), key: 'status' },
  { name: t('partner.revshare.transactions.table.amount'), key: 'amount' },
  { name: t('partner.revshare.transactions.table.income'), key: 'income' },
  { name: t('partner.revshare.transactions.table.date'), key: 'date' },
];

export const getCampaignTypeColors = () => ({
  CPL: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
  RevShare: { bg: 'bg-[rgba(0,111,238,0.2)]', text: 'text-partner' },
});

export const getTransactionTypeLabel = (type: string, t: (key: string) => string): string => {
  const typeMap: Record<string, string> = {
    tips: t('partner.revshare.transactions.transactionTypes.tips'),
    subscription: t('partner.revshare.transactions.transactionTypes.subscription'),
    message: t('partner.revshare.transactions.transactionTypes.messagePayment'),
    messages: t('partner.revshare.transactions.transactionTypes.messagePayment'),
    chat_messages: t('partner.revshare.transactions.transactionTypes.messagePayment'),
    post: t('partner.revshare.transactions.transactionTypes.posts'),
    posts: t('partner.revshare.transactions.transactionTypes.posts'),
    stream: t('partner.revshare.transactions.transactionTypes.stream'),
  };
  return typeMap[type] || type;
};
